import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {useGetRadii} from "../../api/get-radii";
import {NumberBox} from "devextreme-react/number-box";
import {SelectedMaterial} from "../../types/SelectedMaterial";
import {CheckBox} from 'devextreme-react/check-box';
import Validator from "devextreme-react/validator";
import {RequiredRule} from "devextreme-react/form";

export function RadiiColumnControl({group}: { group: SelectedMaterial }) {
    const context = useCountertops();
    const Radii = useGetRadii(context.dealerId, group.prodQteGrpID ?? 0, context.customerZip);
    const [selectedRadii, setSelectedRadii] = useState<Map<number, number | undefined>>(new Map<number, number | undefined>());
    const [checkedState, setCheckedState] = useState<Map<number, boolean>>(new Map<number, boolean>());

    useEffect(() => {
        let map = new Map<number, number | undefined>();
        let checkedMap = new Map<number, boolean>();
        group.radii.forEach(item => {
            map.set(item.productID, item.qty);
            checkedMap.set(item.productID, true);
        });

        setSelectedRadii(map);
        setCheckedState(checkedMap);
    }, [group.radii])

    if (Radii.isLoading)
        return <></>

    return (
        <>
            <p className={"group-name"}>{group.name}</p>
            <table className={'split-column'}>
                <tbody>
                {Radii.data.map(radius =>
                    <tr key={radius.productID}>
                        <td style={{width: '30px', textAlign: "center"}}>
                            <CheckBox
                                value={checkedState.get(radius.productID) ?? false}
                                onValueChanged={(e) => {
                                    if (e.event) {
                                        if (e.value) {
                                            context.updateRadius(group.prodQteGrpID, radius.productID, undefined);
                                        } else {
                                            context.removeRadius(group.prodQteGrpID, radius.productID);
                                        }
                                    }
                                }}
                            />
                        </td>
                        <td>
                            {radius.sku}&nbsp;
                        </td>
                        <td>
                            {radius.name}
                        </td>
                        <td>
                            <img src={radius.imageUrl} style={{maxWidth: '30px'}}/>
                        </td>
                        <td style={{width: '62px'}}>
                            <NumberBox
                                min={1}
                                style={{width: '60px'}}
                                showSpinButtons={true}
                                value={selectedRadii.get(radius.productID)}
                                disabled={!(checkedState.get(radius.productID) ?? false)}
                                valueChangeEvent='blur'
                                format={'fixedPoint'}
                                onValueChanged={(e) => {
                                    if (e.event) {
                                        context.updateRadius(group.prodQteGrpID, radius.productID, e.value ?? undefined)
                                    }
                                }}
                            >
                                <Validator>
                                    <RequiredRule message={"Quantity must be set and greater than 0"}></RequiredRule>
                                </Validator>
                            </NumberBox>
                        </td>
                        <td style={{width: '42px'}}>
                            {radius.uom}
                        </td>

                    </tr>
                )}
                </tbody>
            </table>
        </>
    );
}
